import { Button } from '@mui/material';

import { useHistory } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function GoBackButton() {

    const history = useHistory();

    const handleGoBack = () => {
        history.goBack();
    };
    
    return (
        <Button onClick={handleGoBack} variant="contained" color="secondary" fullWidth>
            <ArrowBackIcon />
            Volver
        </Button>
    );
};
